import React from 'react';
import { observer } from 'mobx-react'
import { styled } from "../../stitches.config"
import { bodyLarge, bodyStrong, h1, h2 } from '../commonStyles/Fonts';
import useMediaQuery from "../../helpers/useMediaQuery";
import TwoDots from '../assets/icons/dots-left.svg';
import Ball from '../assets/icons/football-ball.svg';

type ExtendedTeam = {
    name: string;
    img: any;
    shortcut: string;
    goals: Array<string>;
    score: number;
}

type ExtendedProps = {
    backgroundImg?: any;
    teams: Array<ExtendedTeam>;
};

interface LiveMatchResultProps {
    data: ExtendedProps;
}

const LiveMatchResult: React.FC<LiveMatchResultProps> = observer(({
    data,
}) => {
    const isDesktop = useMediaQuery('bp4');
    const {
        backgroundImg,
        teams,
    } = data;

    return (

        <SportsCoverageContent>
            <Score>
                <Details className={isDesktop ? h1() : h2()}>

                    {isDesktop ? teams[0].name : teams[0].shortcut}
                    <img src={teams[0].img?.img} />
                    <div>
                        {teams[0].score}<Dots />{teams[1].score}
                    </div>
                    <img src={teams[1].img?.img} />
                    {isDesktop ? teams[1].name : teams[1].shortcut}
                </Details>
            </Score>
            <Goals>
                {teams.map((team, i) =>
                    <GoalsWrapper className={"goals-wrapper-" + i}>
                        {team.goals.map((goal) =>
                            <>
                                {goal && <p className={isDesktop ? bodyLarge() : bodyStrong()}>{goal}<span></span></p>}
                            </>
                        )}
                    </GoalsWrapper>
                )}
            </Goals>
            {backgroundImg.img && <img src={backgroundImg.img} />}
            <OpacityLayer />
        </SportsCoverageContent>
    );
});

const Dots = styled('span', {
    backgroundImage: `url("${TwoDots}")`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    height: "16px",
    width: "16px",
    display: "flex",
    marginLeft: "10px",
    "@bp4": {
        height: "22px",
        width: "22px",
        marginLeft: "16px",
    }
})

const OpacityLayer = styled('div', {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    minHeight: "302px",
    height: "100%",
    zIndex: 2,
    background: "linear-gradient(0deg, rgba(19, 18, 18, 0.6), rgba(19, 18, 18, 0.6))",
    opacity: 1,
    "@bp4": {
        background: "linear-gradient(0deg, rgba(19, 18, 18, 0.4), rgba(19, 18, 18, 0.4))",
    },
})

const SportsCoverageContent = styled('div', {
    width: "100%",
    background: "linear-gradient(0deg, rgba(19, 18, 18, 0.4), rgba(19, 18, 18, 0.4))",
    display: "flex",
    justifyContent: "center",
    alingItems: "center",
    flexDirection: "column",
    position: "relative",
    minHeight: "302px",
    padding: "40px 0",
    "@bp4": {
        minHeight: "488px",
    },
    "img": {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        objectFit: "cover",
        "@bp4": {
            minHeight: "488px",
        },
    }
})

const Score = styled('div', {
    position: "relative",
    zIndex: 10,
    color: "$grayscale0Fixed",
    paddingBottom: "8px",
    maxWidth: "1272px",
    borderBottom: "1px solid #F5F5F51A",
    marginLeft: "auto",
    marginRight: "auto",
    "@bp4": {
        paddingBottom: "14px",
    }
})

const Details = styled('div', {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textTransform: "uppercase",
    "@bp4": {
        textTransform: "capitalize"
    },
    "& img": {
        width: "38px",
        height: "38px",
        borderRadius: "38px",
        minHeight: "auto",
        position: "static",
        margin: "0 9px",
        "@bp4": {
            margin: "0 24px",
            width: "60px",
            height: "60px",
            borderRadius: "60px",
        }
    },
    "& div": {
        margin: "0 10px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    }
})

const Goals = styled('div', {
    position: "relative",
    zIndex: 10,
    display: "flex",
    justifyContent: "center",
    alingItems: "center",
    marginTop: "24px",
    "@bp4": {
        marginTop: "32px",
    },
    "& .goals-wrapper-0": {
        padding: "0 19px 0 20px !important",
        borderRight: "1px dashed #F5F5F533",
        "& p": {
            marginLeft: "auto",
        }
    },
    "& .goals-wrapper-1": {
        "& p": {
            display: "flex",
            flexDirection: "row-reverse",
            "& span": {
                margin: "0 6px 0 0",
            }
        }
    }
})

const GoalsWrapper = styled('div', {
    width: "calc(50% - 20px)",
    gap: "8px",
    display: "flex",
    flexDirection: "column",
    padding: "0 20px",
    "& p": {
        background: "$grayscale100Fixed",
        color: "$grayscale0Fixed",
        width: "fit-content",
        padding: "4px 12px",
        margin: "0px",
        display: "flex",
        "& span": {
            width: "16px",
            height: "16px",
            backgroundImage: `url("${Ball}")`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            display: "block",
            marginLeft: "6px",
            "@bp4": {
                marginLeft: "9px",
                width: "24px",
                height: "24px",
            }
        }
    }
})


export default LiveMatchResult